import { AppTooltip } from '../../@components'
import { IconSeekers } from 'ui-seeker/core'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { getAppUserData } from '../../@utils'


export default function BottomNavLogoutButton() {

    const { t } = useTranslation('navigation')
    const { username } = getAppUserData()


    return <a className="toolItem" href="/logout">
            <span className="toolIcon">
                <AppTooltip
                    title={t('user.logoutTooltip', { username })}
                    placement="right"
                >
                    <IconSeekers icon="sign-out" iconType="fontAwesome" />
                </AppTooltip>
            </span>
    </a>
}